import api from '../services/api';

const Bioma = {
  create : async function (data) {
    return await api.post('biomas', data)
    .then(response=>response)
    .catch(error=>error);
  },

  delete : async function (bioma_id) {
    return await api.delete(`biomas/id/${bioma_id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Um item pelo id (usado pelas páginas de edição do painel administrativo).
  findById : async function (id) {
    return await api.get(`biomas/id/${id}`)
    .then(response=>response)
    .catch(error=>error);
  },

  // Listagem paginada com busca opcional (usada pelas listas do painel administrativo).
  listar : async function (page = 1, limit = 10, busca = '') {
    const termo = (busca || '').trim();
    const url = termo
      ? `biomas/data/${encodeURIComponent(termo)}/${page}/${limit}`
      : `biomas/all/${page}/${limit}`;
    return await api.get(url)
    .then(response=>response)
    .catch(error=>error);
  },
  findAll : async function () {
    return await api.get('biomas/all/1/7')
    .then(response=>response)
    .catch(error=>error);
  },

  findSearch : async function (data) {
    return await api.get(`biomas/data/${data}/1/20`)
    .then(response=>response)
    .catch(error=>error);
  }
}

export default Bioma;
